import axios from "axios";
import ApiUrl from "../../constant/endpoint";

import {
  GET_HOMEPAGE_REQUEST,
  GET_HOMEPAGE_SUCCESS,
  GET_HOMEPAGE_FAILURE,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAILURE,
} from "../constants/customerConstant";

export const getCustomerProfileActionFn = (userId) => async (dispatch) => {
  try {
    dispatch({ type: GET_PROFILE_REQUEST });
    const URL = `${ApiUrl.getUserById}?userId=${userId}`;
    const { data } = await axios.get(URL);
    if (data.success) {
      dispatch({
        type: GET_PROFILE_SUCCESS,
        payload: data.response,
      });
    } else {
      dispatch({
        type: GET_PROFILE_FAILURE,
        payload: "Failed to get user profile",
      });
    }
    return data;
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: GET_PROFILE_FAILURE,
        payload: "Internal Server Error",
      });
    } else {
      dispatch({
        type: GET_PROFILE_FAILURE,
        payload: error.response.data,
      });
    }
  }
};

export const deleteCustomerAction = (userId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CUSTOMER_REQUEST });
    const URL = `${ApiUrl.deleteCustomer}?userId=${userId}`;

    const { data } = await axios.delete(URL);
    console.log("response", data);
    if (data.success) {
      dispatch({
        type: DELETE_CUSTOMER_SUCCESS,
        payload: data.success,
      });
      console.log("response", data);
      return true;
    }
    return false;
  } catch (error) {
    dispatch({
      type: DELETE_CUSTOMER_FAILURE,
      payload: error.response.data,
    });
  }
};
